import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HeartRatePage = lazy(() => import("./HeartRatePage"));

const HeartRatePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HeartRatePage />
    </Suspense>
  );
};

export default HeartRatePageLazy;
